<template>
  <HeaderTitle :back-target-func="changeView">
    <template #top>{{ t("code.scan.screen.title") }}</template>
    <template #bottom>{{ t("code.web.subtitle") }}</template>
  </HeaderTitle>

  <div class="max-w-xs">
    <h5 class="text-medium">{{ t("data.privacy.attention") }}</h5>
    <h2 class="text-large">
      {{ t("data.privacy.consent.body") }}
    </h2>
  </div>
  <div class="w-96 flex flex-col justify-center items-center mx-auto mb-14">
    <div class="flex flex-col mt-8">
      <ToggleElement
        v-model="consent.termsOfUse"
        :label="t('legal.terms.of.use.switch.link.caption')"
        class="mb-2"
        :label-event="openTermsOfUseModal"
      />
      <ToggleElement
        v-model="consent.privacyPolicy"
        class="mb-2"
        :label="t('legal.data.privacy.switch.link.caption')"
        :label-event="openPrivacyPolicyModal"
      />
      <ToggleElement
        v-model="consent.allowTracking"
        :label="t('legal.data.usage.2.switch.link.caption')"
      />
    </div>
  </div>

  <BaseButton
    class="mt-4 w-44 text-center mx-auto"
    :variant="
      !consent.termsOfUse || !consent.privacyPolicy ? 'outline' : 'primary'
    "
    :disabled="!consent.termsOfUse || !consent.privacyPolicy"
    @click="handleAccept"
    >{{ t("bottom.sheet.utils.accept.button.text") }}
  </BaseButton>

  <TermsOfUseModal
    :open="termsOfUseModalOpen"
    @close="termsOfUseModalOpen = false"
  />
  <PrivacyAndTermsOfUseModal
    :open="privacyPolicyModalOpen"
    @close="privacyPolicyModalOpen = false"
  />
  <AllowTrackingModal
    :open="allowTrackingModalOpen"
    @close="allowTrackingModalOpen = false"
  />
</template>
<script setup lang="ts">
import ToggleElement from "../form/ToggleElement.vue";
import { ref } from "vue";
import BaseButton from "../layout/button/BaseButton.vue";
import TermsOfUseModal from "../legal/TermsOfUseModal.vue";
import PrivacyAndTermsOfUseModal from "../legal/PrivacyAndTermsOfUseModal.vue";
import AllowTrackingModal from "../legal/AllowTrackingModal.vue";
import { useConsentStore } from "../../../store/v2/consent.ts";
import { useI18n } from "vue-i18n";
import HeaderTitle from "../layout/header/HeaderTitle.vue";
import { getCurrentInstance } from "vue";
import { useCookieConsent } from "../../../plugins/useCookieConsent";
import { useClientStore } from "../../../store/v2/client";

const { t } = useI18n();

const consent = useConsentStore();

const termsOfUseModalOpen = ref(false);
const privacyPolicyModalOpen = ref(false);
const allowTrackingModalOpen = ref(false);

defineProps({
  open: Boolean,
});

const emit = defineEmits(["change-view"]);

const clientStore = useClientStore();
const instance = getCurrentInstance();
const { installPlugins, uninstallPlugins } = useCookieConsent(
  instance,
  clientStore
);

function handleAccept() {
  if (consent.allowTracking) {
    installPlugins();
  } else {
    uninstallPlugins();
  }
  emit("change-view", "data");
}

function openTermsOfUseModal() {
  termsOfUseModalOpen.value = true;
}

function openPrivacyPolicyModal() {
  privacyPolicyModalOpen.value = true;
}

function openAllowTrackingModal() {
  allowTrackingModalOpen.value = true;
}

function changeView(view: string) {
  emit("change-view", "code");
}
</script>
